<script>
import EntitiesTable from '$common/EntitiesTable'
export default {
  name: 'AdminInvoices',
  components: {
    'entities-table': EntitiesTable,
  },
  data () {
    return {
      guardians: {},
      invoices: [],
      cells: [
        {
          name: 'Name',
          getInfo: invoice => this.guardians[invoice.guardian_id].name,
          sortFunc: (a, b) => this.guardians[a.guardian_id].name.localeCompare(this.guardians[b.guardian_id].name)
        },
        {
          name: 'Email',
          getInfo: invoice => this.guardians[invoice.guardian_id].email,
          sortFunc: (a, b) => this.guardians[a.guardian_id].email.localeCompare(this.guardians[b.guardian_id].email)
        },
        {
          name: 'Amount',
          getInfo: invoice => `$${invoice.amount}`,
          sortFunc: (a, b) => a.amount.localeCompare(b.amount)
        },
        {
          name: 'Status',
          getInfo: invoice => invoice.status.toLowerCase(),
          sortFunc: (a, b) => a.status.localeCompare(b.status)
        },
        {
          name: 'Date Sent',
          getInfo: invoice => new Date(invoice.created).toLocaleDateString(),
          sortFunc: (a, b) => a.created < b.created ? 1 : -1
        },
        {
          name: 'Message',
          getInfo: invoice => invoice.message,
          sortFunc: (a, b) => a.message.localeCompare(b.message)
        },
        {
          name: 'Date Resolved',
          getInfo: invoice => invoice.resolved ? new Date(invoice.resolved).toLocaleDateString() : '-',
          sortFunc: (a, b) => (a.resolved || 0) < (b.resolved || 0) ? 1 : -1
        },
        {
          name: 'Stripe ID',
          getInfo: invoice => invoice.stripe_charge_id || '-',
          sortFunc: (a, b) => (a.stripe_charge_id || '').localeCompare(b.stripe_charge_id || '')
        },
      ],
      sorting: {
        ascending: true,
        by: 'Date Sent',
      },
      isReady: false,
    }
  },
  computed: {
    filteredInvoices () {
      const sortFunc = this.cells.find(cell => cell.name === this.sorting.by).sortFunc
      const sorted = this.$clone(this.invoices).sort(sortFunc)
      return this.sorting.ascending ? sorted : sorted.reverse()
    },
  },
  methods: {
    async getInvoices () {
      const invoiceAndGuardianPromises = (await this.$firestore.collection('invoices').get()).docs.map(doc => doc.data())
        .map(async invoice => {
          if (!this.guardians[invoice.guardian_id]){
            const guardian = (await this.$firestore.collection('users').doc(invoice.guardian_id).get()).data()
            this.guardians[guardian.id] = guardian
          }
          this.invoices.push(invoice)
        })
      await Promise.all(invoiceAndGuardianPromises)
      this.isReady = true
    },
  },
  async mounted () {
    await this.getInvoices()
  },
}
</script>

<template lang="pug">
  #admin-guardians-main.admin-main
    .admin-guardians-container.admin-container
      .admin-title Invoices
      .admin-content
        entities-table(
          :entities='filteredInvoices'
          :cells='cells'
          :initialSorting='sorting'
          :isReady='isReady'
          customColumnWidths='200px 275px 90px 90px 150px 200px 150px 250px'
          @onSortingChange='newSorting => sorting = newSorting'
          :tableStyle='{"max-width": "calc(100vw - 400px)"}'
        )
</template>

<style lang="sass" scoped>
  #admin-invoices-main
    .admin-invoices-container
</style>